import { Link, useNavigate } from 'react-router-dom';
import { Button, Col, Container, ProgressBar, Row, Spinner } from 'react-bootstrap';
import '../../components/my-account-nav.scss';
import MenuButton from '../../app/styles/components/MenuButton';
import { useSelector } from 'react-redux';
import { selectIsMobileRoute } from '../mobile/mobileSlice';
import { selectCustomerDetails, selectCustomerDetailsIsLoaded, selectCustomerDetailsIsLoading } from './customerDetailSlice';
import { useEffect, useState } from 'react';
import MyAccountPage from '../../pages/MyAccountPage';
import { selectToken } from '../user/userSlice';
import Window from '../../utils/Window';

export default function AccountSettingsWrapper() {
    const navigate = useNavigate();
    const token = useSelector(selectToken);
    const [progress, setProgress] = useState(0);
    const customerData = useSelector(selectCustomerDetails);
    const customerLoading = useSelector(selectCustomerDetailsIsLoading);
    const customerLoaded = useSelector(selectCustomerDetailsIsLoaded);
    const customerDetails = customerData?.user_data;
    const AppURL = useSelector(selectIsMobileRoute);
    const QURLParams = AppURL ? `/?${AppURL}` : '/';

    useEffect(() => {
        if (customerDetails) {
            const totalFields = Object.keys(customerDetails).filter(key => !key.includes('address_two') && !key.includes('number_of_children_in_household') && !key.includes('imageUrl')).length;
            const numCompletedFields = Object.values(customerDetails).filter((val, index) => val !== "" && val !== null && !Object.keys(customerDetails)[index].includes('address_two') && !Object.keys(customerDetails)[index].includes('number_of_children_in_household') && !Object.keys(customerDetails)[index].includes('imageUrl')).length;
            const ProgressBar = Math.round((numCompletedFields / totalFields) * 100);
            setProgress(ProgressBar);
        }
    }, [customerDetails]);

    if (!token || !Window.isMobile()) {
        if (!Window.isMobile()) {
            navigate(`/my-account${QURLParams}`)
        }

        return (
            <MyAccountPage />
        )
    }

    return (
        <Container fluid="lg">
            <div className='my-account-nav my-md-5'>
                <Row>
                    <Col xs={3} className='p-0 px-2 pt-2'>
                        <MenuButton />
                    </Col>
                    <Col xs={9} className='p-0 px-3 d-flex align-items-center justify-content-end'>
                        <span className="text-uppercase fw-400 fs-32px font-league-gothic">ACCOUNT SETTINGS</span>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/my-account/gift-cards${QURLParams}`}
                            variant="white"
                            size="lg"
                            className={`text-uppercase no-hover-effect fs-15px font-glegoo myaccountbox d-flex flex-column align-items-center justify-content-center text-white p-2`}
                        >
                            GIFT CARDS & STORE CREDITS
                        </Button>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/my-account/mightypoints${QURLParams}`}
                            variant="white"
                            size="lg"
                            className={`text-uppercase no-hover-effect fs-15px font-glegoo myaccountbox d-flex flex-column align-items-center justify-content-center text-white p-2`}
                        >
                            MIGHTY POINTS
                        </Button>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/my-account/my-membership-details${QURLParams}`}
                            variant="white"
                            size="lg"
                            className={`text-uppercase no-hover-effect fs-15px font-glegoo myaccountbox d-flex flex-column align-items-center justify-content-center text-white p-2`}
                        >
                            MY MEMBERSHIP
                        </Button>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/my-account/edit-account${QURLParams}`}
                            variant="white"
                            size="lg"
                            className={`text-uppercase no-hover-effect mobileprogressbar fs-15px font-glegoo myaccountbox d-flex flex-column align-items-center justify-content-center text-white p-2`}
                        >
                            EDIT ACCOUNT {(!customerLoading && customerLoaded && customerData) ? '' : <Spinner animation="border" as="span" size="sm" />}
                            <div className='pt-2 w-full mobileprogressbar'>
                                {progress === 0
                                    ? <ProgressBar now={0} label={`${0}%`} className='h-30px px-2' />
                                    : <ProgressBar now={progress} label={`${progress}%`} className='h-30px' />}
                            </div>
                        </Button>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/my-account/address${QURLParams}`}
                            variant="white"
                            size="lg"
                            className={`text-uppercase no-hover-effect fs-15px font-glegoo myaccountbox d-flex flex-column align-items-center justify-content-center text-white p-2`}
                        >
                            EDIT ADDRESS
                        </Button>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/my-account/change-password${QURLParams}`}
                            variant="white"
                            size="lg"
                            className={`text-uppercase no-hover-effect fs-15px font-glegoo myaccountbox d-flex flex-column align-items-center justify-content-center text-white p-2`}
                        >
                            CHANGE PASSWORD
                        </Button>
                    </Col>
                    <Col xs={4} className='p-0'>
                        <Button
                            as={Link as any}
                            to={`/my-account/payment-method${QURLParams}`}
                            variant="white"
                            size="lg"
                            className={`text-uppercase no-hover-effect fs-15px font-glegoo myaccountbox d-flex flex-column align-items-center justify-content-center text-white p-2`}
                        >
                            EDIT PAYMENT METHOD
                        </Button>
                    </Col>
                </Row>
            </div>
        </Container>
    )
}
